import React from 'react'

import { Doughnut } from 'react-chartjs-2'
import Skeleton from 'react-loading-skeleton'
import { Icon } from './../../../components/Layout'

import Card from './Card'

const GraficoTotalTipo = React.memo(({ load, dataGrafico }) => {

    const [fontColor, setFontColor] = React.useState('#6B6F76')

    React.useEffect(() => {
        const updateColor = () => {
            const color = getComputedStyle(document.body).getPropertyValue('--color-text-secondary').trim()
            if (color) setFontColor(color)
        }

        updateColor()

        const observer = new MutationObserver(updateColor)
        observer.observe(document.body, { attributes: true, attributeFilter: ['data-theme', 'class'] })
        observer.observe(document.documentElement, { attributes: true, attributeFilter: ['data-theme', 'class'] })

        return () => observer.disconnect()
    }, [])

    return (
        <Card>
            {
                load ?
                    <Skeleton height={12} width={160} /> :
                    <div className="filter-header-title">
                        <Icon name='ti-pie-chart' />
                        <span>Totalizador por tipo</span>
                    </div>
            }
            <div className='card-grafico-totalizador'>
                {
                    load ?
                        <div style={{ display: 'flex' }}>
                            <div style={{ marginTop: 20 }}>
                                <Skeleton count={3} height={8} width={70} />
                            </div>
                            <div>
                                <Skeleton circle height={85} width={85} />
                            </div>
                        </div> :
                        <Doughnut
                            data={dataGrafico}
                            legend={{
                                display: true,
                                position: 'left',
                                labels: {
                                    boxWidth: 6,
                                    fontSize: 10,
                                    fontColor: fontColor
                                }
                            }}
                        />
                }
            </div>
        </Card>
    )
})

export default GraficoTotalTipo